// Телефон капитана. В базе players.phone лежит в формате +79991234567,
// админ вводит только 10 цифр — +7 подставляется автоматически.

export const digitsOnly = (value) => (value || '').replace(/\D/g, '');

export const toStoredPhone = (input) => `+7${digitsOnly(input).slice(-10)}`;

export const isPhoneValid = (input) => digitsOnly(input).length === 10;

// Полный номер игрока админу не показываем — только последние 4 цифры
export const maskPhone = (phone) => {
  if (!phone) return '';
  const digits = digitsOnly(phone);
  if (digits.length < 4) return '******';
  return `******${digits.slice(-4)}`;
};
